import { makeStyles } from 'tss-react/mui';

export const useBaseChainsHeaderStyles = makeStyles()(theme => ({
  root: {
    display: 'grid',
    alignItems: 'center',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: theme.spacing(7),
    marginBottom: theme.spacing(4),

    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr',
      gap: theme.spacing(5),
    },
  },
  first: {
    gridColumnStart: 1,
    gridColumnEnd: 3,
    display: 'flex',
    gap: theme.spacing(3),
  },
  chainsListSearch: {
    height: 40,
    [theme.breakpoints.down('sm')]: {
      height: 32,
    },

    '&:hover': {
      backgroundColor: theme.palette.surface.tertiary,
    },
  },
  chainsSortSelect: {
    height: 40,
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.shape.borderRadiusMd,
    [theme.breakpoints.down('sm')]: {
      height: 32,
    },

    '&:hover': {
      backgroundColor: theme.palette.surface.tertiary,
    },
  },
}));
